import React, { useEffect } from "react";
import { connect } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import { LucideCalendarDays } from "lucide-react";
import ProfileCard from "./ProfileCard";



const BirthdaysTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters, 
	doDelete,
	doRecordReset
}) => {

	
return (
	<HeaderComponent
		title="Public Holidays"
		description="Holidays by location"
		bgcolor="bg-emerald-50"
		icon={<LucideCalendarDays size={20}/>}
		colorTheme="flat-green"
		shadow="shadow-sm"
		border="border-b"
	>
		<div className= "overflow-y-auto p-1 h-[500px]">
			<ProfileCard
				name="All Saints' Day"
				location="Philippines"
				date="Nov 30, 2025"
			/>
			<ProfileCard
				name="All Saints' Day"
				location="Philippines"
				date="Nov 30, 2025"
			/>
			<ProfileCard
				name="All Saints' Day"
				location="Philippines"
				date="Nov 30, 2025"
			/>
			<ProfileCard
				name="All Saints' Day"
				location="Philippines"
				date="Nov 30, 2025"
			/>
			<ProfileCard
				name="All Saints' Day"
				location="Philippines"
				date="Nov 30, 2025"
			/>
			<ProfileCard
				name="All Saints' Day"
				location="Philippines"
				date="Nov 30, 2025"
			/>
		</div>
		
	</HeaderComponent>
  );
};

const mapStateToProps = (state) => ({
	// recordList: state.trainingClass.trainingClassList?.items,
	// pagination: state.trainingClass.trainingClassList?.pagination,
	// filters: state.trainingClass.trainingClassList?.filters,
	// requesting: state.trainingClass.trainingClassList?.requesting,
	// error: state.trainingClass.trainingClassList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	// doSearch: (filters) => dispatch(getTrainingClassList(filters)),
	// doDelete: (id) => dispatch(doTrainingClassDelete(id)),
	// doRecordReset: () => dispatch(doTrainingClassReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BirthdaysTable);
